import type { Network } from '../model'
import type { ColorVariant } from '@blade/ui-kit'

export const NETWORK_COLOR_MAP: Record<Network.Network, ColorVariant> = {
  solana: 'solana',
  ethereum: 'ethereum',
  base: 'base',
  bsc: 'bsc',
  ton: 'ton',
}
